import Swiper from 'swiper/bundle';

// Touch axis lock for every horizontal Swiper (operator 2026-10-31: on phones the page bobbed up and down while a
// slider moved sideways). Swiper 9 drives the slide with pointer events, which cannot stop the page from scrolling,
// and its container has touch-action: pan-y, so on a slightly diagonal swipe Safari scrolled the page by the
// vertical part of the gesture. The first few pixels decide the axis, as on rebelwalls.com: sideways, and the page
// stays put until the finger lifts; up or down, and the page scrolls as usual. Registered as a Swiper module, so
// it reaches every slider built from this bundle (lists, galleries, the product modal).
function lockTouchAxis(el) {
    if (!el || el.swiperAxisLock) return;
    el.swiperAxisLock = true;
    let startX = 0, startY = 0, axis = null;
    el.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        axis = null;
    }, {passive: true});
    el.addEventListener('touchmove', function (e) {
        if (e.touches.length > 1) return;   // pinch zoom stays with the browser
        const dx = Math.abs(e.touches[0].clientX - startX);
        const dy = Math.abs(e.touches[0].clientY - startY);
        if (!axis) {
            if (dx < 4 && dy < 4) return;
            axis = dx > dy ? 'x' : 'y';
        }
        if (axis === 'x' && e.cancelable) e.preventDefault();
    }, {passive: false});
}
Swiper.use([function AxisLock({swiper, on}) {
    on('init', function () {
        if (swiper.isHorizontal()) lockTouchAxis(swiper.el);
    });
}]);

const SwiperSelector = '[data-swiper]';
const SwiperDefault = {
    breakpointsInverse: true,
    observer: true
};
window.initSwipers = function () {
    let SliderProduct = false;
    let SwiperProductThumbnails = false;
    $(SwiperSelector).each(function (i , slider) {
        if($(slider).hasClass('swiper-initialized')) {

        }else{
            let SwiperOptions = JSON.parse($(slider).attr('data-swiper')) || {};
            if($(window).width() < 768) {
                SwiperOptions.autoplay = false;
            }
            if($(slider).hasClass('swiper-product')){
                SliderProduct = slider;
            }else{
                slider.options = $.extend({}, SwiperDefault, SwiperOptions);
                const swiper = new Swiper(slider, slider.options);
                if($(slider).hasClass('swiper-product-thumbnails')){
                    SwiperProductThumbnails = swiper;
                }
            }
        }
    });
    if(SliderProduct) {
        const SwiperOptions = JSON.parse($(SliderProduct).attr('data-swiper')) || {};
        SliderProduct.options = $.extend({}, SwiperDefault, SwiperOptions);
        if(SwiperProductThumbnails){
            SliderProduct.options.thumbs = {
                swiper: SwiperProductThumbnails,
            }
        }
        const swiper = new Swiper(SliderProduct, SliderProduct.options);
    }
}
$(document).ready(function () {
    initSwipers();
});
